<template>

    <div class="page-wrapper">

        <!-- Menu Superior de Navegación -->
        <navbar-new></navbar-new>

        <!-- Slider de Fotos -->
        <slider></slider>

        <!-- Acerca de Nosotros Text => Helping (Debajo del Slider)-->
        <about></about>

        <!-- Otros Servicios Home Fotos y demas-->
        <causes></causes>

        <!-- Unete a nuestros proximos eventos => Join our latest -->
        <!-- <events></events> -->

        <!-- Cards Electricidad y Control en Home -->
        <feature></feature>
        
        <!-- Iconos de Marcas -->
        <brand></brand>

        <!-- Galería de Fotos TEXT => Our Photo Gallery  -->
        <gallery></gallery>

        <!-- Preguntas Frecuentes -->
        <!-- <faq></faq> -->

        <!-- Otros Servicios -->
        <news></news>


        <!-- <mobile-nav></mobile-nav> -->

        <!-- <search></search> -->

        <!-- Pie de Página -->
        <footer-new></footer-new>

        

    </div>
</template>
  
<script>
import navbarNew from '../components/navbar.vue'

import footerNew from '../components/footer.vue'

import slider from '../components/home/slider.vue'

import about from '../components/home/about.vue'

import causes from '../components/home/causes.vue'

// import events from '../components/home/events.vue'

import feature from '../components/home/feature.vue'

import brand from '../components/home/brand.vue'

import gallery from '../components/home/gallery.vue'

// import faq from '../components/home/faq.vue'

import news from '../components/home/news.vue'


import mobileNav from '../components/home/mobileNav.vue'

import search from '../components/home/search.vue'

import { features } from 'process'

  export default {
    components: {
    navbarNew,
    footerNew,
    slider,
    about,
    causes,
    // events,
    feature,
    brand,
    gallery,
    // faq,
    news,
    mobileNav,
    search,
    features
}
  }
</script>
  